import cloneDeep from 'lodash/cloneDeep';

import Address from 'app/models/address';
import Tracker from 'app/models/tracker';
import PostageLabel from 'app/models/postage_label';
import Parcel from 'app/models/parcel';

import { appUrl } from 'utils/wrappers';
import { showSuccess, showResponseError } from 'utils/messages';

import Base from 'app/models/base';

export default Base.extend({
  urlRoot: appUrl('shipments'),
  rootKey: 'shipment',

  parse(attributes) {
    const attrs = { rawJSON: cloneDeep(attributes), ...attributes };

    if (attrs.to_address) {
      attrs.to_address = new Address(attrs.to_address);
    }
    if (attrs.from_address) {
      attrs.from_address = new Address(attrs.from_address);
    }
    if (attrs.parcel) {
      attrs.parcel = new Parcel(attrs.parcel);
    }
    if (attrs.postage_label) {
      attrs.postage_label = new PostageLabel(attrs.postage_label);
    }
    if (attrs.tracker) {
      attrs.tracker = new Tracker(attrs.tracker);
    }

    return attrs;
  },

  submitForRefund() {
    const self = this;
    const url = `${this.url()}/refund?mode=${this.get('mode')}`;
    this.sync('read', this, {
      url,
      success(_, status, response) {
        showSuccess('Your refund request was submitted.');
        self.set(self.parse(JSON.parse(response.responseText)), {});
      },
      error(response) {
        showResponseError(response);
      },
    });
  },
});



// WEBPACK FOOTER //
// ./app/models/shipment.js